import styled from 'styled-components';
import { Paper } from '@mui/material';

export const StyledPaper = styled(Paper)``;
